<mat-toolbar class="sidemenu-toolbar">
    <i class="icon mdi mdi-database"></i>
    <span class="title">Entity</span>
</mat-toolbar>

<mat-accordion class="mat-list-custom" togglePosition="before" displayMode="flat" *ngIf="entityList.length > 0">
    <ng-container *ngFor="let entity of entityList; let index = index">
        <mat-expansion-panel [expanded]="entity.open" class="mx-2">
            <mat-expansion-panel-header [class.active]="entity.open" class="mat-list-item" mat-ripple
                (click)="onEntityClicked(entity, index)">
                <mat-panel-title class="item-fill">
                    <span>{{ entity.entity_name | titlecase }}</span>
                </mat-panel-title>
                <div class="item-end control-buttons">
                    <button mat-icon-button (click)="$event.stopPropagation();editEntityName(addEntityPopUp, entity.entity_id, entity.entity_name)"><mat-icon>edit</mat-icon></button>
                    <button mat-icon-button color="warn" (click)="$event.stopPropagation();deleteEntity(entity.entity_id)"><mat-icon>delete</mat-icon></button>
                </div>
            </mat-expansion-panel-header>

            <!-- Mapped Pages -->
            <mat-accordion class="mat-list-custom" togglePosition="before" displayMode="flat">

                <mat-expansion-panel [expanded]="matPanelStatus" (opened)="matPanelStatus = true; showselectPageError=false" (closed)="matPanelStatus = false">
                    <mat-expansion-panel-header [class.active]="matPanelStatus" class="mat-list-item" mat-ripple>
                        <mat-panel-title class="item-fill">
                            <span>Mapped Pages</span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-container *ngIf="entityPages.length > 0">
                        <mat-list *ngFor="let page of entityPages; let index = index">
                            <mat-list-item>
                                <span class="d-flex align-items-center justify-content-between gap-3">
                                    <span>{{ page.pageName | titlecase }}</span>
                                    <div class="item-end control-buttons">
                                        <button mat-icon-button color="warn" class="mat-small"
                                            (click)="removePageFromEntity(page.pageId, index)"><mat-icon>delete</mat-icon></button>
                                    </div>
                                </span>
                            </mat-list-item>
                        </mat-list>
                    </ng-container>

                    <mat-form-field *ngIf="isAddAttributes && pageListDropdown.length !=0" appearance="outline" class="mt-2 w-100" [formGroup]="entityForm">
                        <mat-label>Page</mat-label>
                        <mat-select matNativeControl formControlName="attributes" placeholder="Select Page">
                            <ng-container *ngFor="let item of pageListDropdown">
                                <mat-option [value]="item.pageId">{{ item.pageName }}</mat-option>
                            </ng-container>
                        </mat-select>
                        <mat-hint *ngIf="matPanelStatus && showselectPageError" class="text-danger "> Please select a page</mat-hint>
                    </mat-form-field>
                    <button mat-stroked-button color="primary" class="add-button w-100 mt-4" (click)="addPage()" [disabled]="pageListDropdown.length == 0" >
                        <mat-icon>add</mat-icon>
                        Add Page
                    </button>
                </mat-expansion-panel>
            </mat-accordion>

            <!-- Related Entities -->
            <mat-accordion class="mat-list-custom mt-2" togglePosition="before" displayMode="flat">
                <mat-expansion-panel [expanded]="relatedPanelStatus" (opened)="togglePanelRelatedEntity(true)" (closed)="togglePanelRelatedEntity(false)" >
                    <mat-expansion-panel-header [class.active]="relatedPanelStatus" class="mat-list-item" mat-ripple>
                        <mat-panel-title class="item-fill">
                            <span>Related Entities</span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-container *ngIf="relativeEntity.length > 0">
                        <mat-list *ngFor="let entity of relativeEntity; let index = index">
                            <mat-list-item>
                                <span class="d-flex align-items-center justify-content-between gap-3">
                                    <span>{{ entity.entity_name | titlecase }}</span>
                                    <div class="item-end control-buttons">
                                        <button mat-icon-button color="warn" class="mat-small"
                                            (click)="removeRelativeEntityFromEntity(entity.entity_id, index)"><mat-icon>delete</mat-icon></button>
                                    </div>
                                </span>
                            </mat-list-item>
                        </mat-list>
                    </ng-container>

                    <ng-container [formGroup]="entityForm">
                        <mat-form-field *ngIf="isAddRelations" appearance="outline" class="mt-2 w-100" >
                            <mat-label>Related Entity</mat-label>
                            <mat-select matNativeControl formControlName="child" placeholder="Select Entity">
                                <ng-container *ngFor="let item of relatedEntityList">
                                    <mat-option *ngIf="selectedEntityName?.trim()?.toLowerCase() != item.entity_name?.trim()?.toLowerCase()" [value]="item.entity_id">{{ item.entity_name}}</mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>

                        <ng-container *ngIf="showRelativeField" formGroupName="childField">
                            <mat-form-field class="mt-1 w-100" >
                                <mat-label>Parent Entity Field</mat-label>
                                <mat-select matNativeControl formControlName="parent" placeholder="Select Field"  (focus)="handleParentFieldTouch()">
                                    <ng-container *ngFor="let item of entityFields">
                                        <mat-option [value]="item.widgetId">{{ item.widgetLabel }}</mat-option>
                                    </ng-container>
                                </mat-select>
                               
                                <mat-hint [innerHTML]="!buttonClickedParent ? ((parentFieldClicked && entityFields.length === 0 )? 'No Parent Fields' : ''): showselectEntityParentError ? 'Please select Parent field' : ''" class="text-danger"></mat-hint>

                            </mat-form-field>
    
                            <mat-form-field class="mt-1 w-100">
                                <mat-label>Child Entity Field</mat-label>
                                <mat-select matNativeControl formControlName="child" placeholder="Select Field" (focus)="handleChildFieldTouch()">
                                    <ng-container *ngFor="let item of selectedEntityFields">
                                        <mat-option [value]="item.widgetId">{{ item.widgetLabel }}</mat-option>
                                    </ng-container>
                                </mat-select>
                                <mat-hint [innerHTML]="!buttonClickedChild ? ((childFieldClicked && selectedEntityFields.length === 0 )? 'No Child Fields' : ''): showselectEntityChildError ? 'Please select Child field' : ''" class="text-danger"></mat-hint>


                            </mat-form-field>
                        </ng-container>
               
                    </ng-container>
                     
                    <button mat-stroked-button color="primary" class="add-button w-100 mt-3" (click)="addRelatedEntities(); " [disabled]="entityList.length == 1">
                        <mat-icon>add</mat-icon>
                        Add Related Entity
                    </button>
                </mat-expansion-panel>
            </mat-accordion>
          
            <button mat-stroked-button color="primary" class="add-button w-100 mt-3"
                (click)="updateEntity(entity.entity_id)">
                Update Association
            </button> 

        </mat-expansion-panel>
    </ng-container>
</mat-accordion>
    <div class="p-3">
        <button mat-stroked-button color="primary" class="add-button w-100 " (click)="openModal(addEntityPopUp, false)">
            <mat-icon>add</mat-icon>
            Add Entity
        </button>
    </div>
    

<!-- Add or Edit Entity -->
<ng-template #addEntityPopUp>
    <div (keydown.escape)="closeTemplate()" (keydown.enter)="onEnterPressed(popupEntity.entityId)">
        <mat-dialog-content class="add-page-dailog">
            <div class="row">
                <div class="col-12" [formGroup]="entityForm">
                    <h2>
                        <span *ngIf="!isEdit">Add Entity</span>
                        <span *ngIf="isEdit">Edit Entity</span>
                    </h2>
                    <mat-form-field class="w-100" appearance="outline">
                        <mat-label>Entity Name</mat-label>
                        <input matInput placeholder="Entity Name" formControlName="name" (input)="onEntityNameAdd($event)" />
                        <mat-hint class="error-message" *ngIf="!isEntityNameUnique">Entity name already exist</mat-hint>
                    </mat-form-field>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions class="dailog-footer-buttons">
            <button mat-button (click)="closeTemplate()">Cancel</button>
            <button mat-raised-button color="primary" [disabled]="entityForm.invalid || !isEntityNameUnique"
                (click)="saveEntiy(popupEntity.entityId)">Save</button>
        </mat-dialog-actions>
    </div>
</ng-template>
